import axios from "../utils/axios";

export const signIn = async (authData) => {
  const { data } = await axios.post(`/auth`, { ...authData, username: authData.username.toLowerCase() });
  return data;
};
